import { render, staticRenderFns } from "./OCRNodeConfig.vue?vue&type=template&id=64e6ac66&scoped=true"
import script from "./OCRNodeConfig.vue?vue&type=script&lang=js"
export * from "./OCRNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./OCRNodeConfig.vue?vue&type=style&index=0&id=64e6ac66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6ac66",
  null
  
)

export default component.exports